import { AxiosRequestConfig } from 'axios';
import HTTP from 'libs/HTTP';

class SubstanceService extends HTTP {
  config: AxiosRequestConfig = {
    baseURL: this.config.baseURL + '/chatbot-server/api'
  };
  // 获取变量列表
  getList(data: any) {
    return this.get('/entitis', data);
  }
  // 意图变量
  addSubstance(data: any) {
    return this.post('/entitis', data);
  }
  // 编辑变量
  editSubstance(id: any, data: any) {
    return this.put(`/entitis/${id}`, data);
  }
  // 删除变量
  deleteSubstance(ids: any) {
    return this.delete(`/entitis`, { data: ids });
  }
}
export default new SubstanceService();
